var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCanvasVstack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fill",
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 4.25C2 3.55109 2 3.20163 2.11418 2.92597C2.26642 2.55843 2.55843 2.26642 2.92597 2.11418C3.20163 2 3.55109 2 4.25 2H11.75C12.4489 2 12.7984 2 13.074 2.11418C13.4416 2.26642 13.7336 2.55843 13.8858 2.92597C14 3.20163 14 3.55109 14 4.25C14 4.94891 14 5.29837 13.8858 5.57403C13.7336 5.94157 13.4416 6.23358 13.074 6.38582C12.7984 6.5 12.4489 6.5 11.75 6.5H4.25C3.55109 6.5 3.20163 6.5 2.92597 6.38582C2.55843 6.23358 2.26642 5.94157 2.11418 5.57403C2 5.29837 2 4.94891 2 4.25Z",
    fill: "#6C7689"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 11.75C2 11.0511 2 10.7016 2.11418 10.426C2.26642 10.0584 2.55843 9.76642 2.92597 9.61418C3.20163 9.5 3.55109 9.5 4.25 9.5H11.75C12.4489 9.5 12.7984 9.5 13.074 9.61418C13.4416 9.76642 13.7336 10.0584 13.8858 10.426C14 10.7016 14 11.0511 14 11.75C14 12.4489 14 12.7984 13.8858 13.074C13.7336 13.4416 13.4416 13.7336 13.074 13.8858C12.7984 14 12.4489 14 11.75 14H4.25C3.55109 14 3.20163 14 2.92597 13.8858C2.55843 13.7336 2.26642 13.4416 2.11418 13.074C2 12.7984 2 12.4489 2 11.75Z",
    fill: "#6C7689"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fillOpacity: 0,
    d: "M11.75 2H4.25C3.55109 2 3.20163 2 2.92597 2.11418C2.55843 2.26642 2.26642 2.55843 2.11418 2.92597C2 3.20163 2 3.55109 2 4.25C2 4.94891 2 5.29837 2.11418 5.57403C2.26642 5.94157 2.55843 6.23358 2.92597 6.38582C3.20163 6.5 3.55109 6.5 4.25 6.5H11.75C12.4489 6.5 12.7984 6.5 13.074 6.38582C13.4416 6.23358 13.7336 5.94157 13.8858 5.57403C14 5.29837 14 4.94891 14 4.25C14 3.55109 14 3.20163 13.8858 2.92597C13.7336 2.55843 13.4416 2.26642 13.074 2.11418C12.7984 2 12.4489 2 11.75 2Z",
    stroke: "#6C7689",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillOpacity: 0,
    d: "M11.75 9.5H4.25C3.55109 9.5 3.20163 9.5 2.92597 9.61418C2.55843 9.76642 2.26642 10.0584 2.11418 10.426C2 10.7016 2 11.0511 2 11.75C2 12.4489 2 12.7984 2.11418 13.074C2.26642 13.4416 2.55843 13.7336 2.92597 13.8858C3.20163 14 3.55109 14 4.25 14H11.75C12.4489 14 12.7984 14 13.074 13.8858C13.4416 13.7336 13.7336 13.4416 13.8858 13.074C14 12.7984 14 12.4489 14 11.75C14 11.0511 14 10.7016 13.8858 10.426C13.7336 10.0584 13.4416 9.76642 13.074 9.61418C12.7984 9.5 12.4489 9.5 11.75 9.5Z",
    stroke: "#6C7689",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCanvasVstack);
export default __webpack_public_path__ + "static/media/canvas-vstack.85f35cb088b0bb349f05034d66983f49.svg";
export { ForwardRef as ReactComponent };